import { defineStore } from "pinia";
import { useUserInfoStore } from "./userInfo.js";
import _ from "lodash";

export const useContractsStore = defineStore({
  id: "contractInfo",
  state: () => {
    return {
      contracts: null,
    };
  },
  getters: {
    hasEngineTypes() {
      return (engine) => {
        const userInfo = useUserInfoStore();
        if (userInfo.isPst) {
          return true;
        } else {
          if (this.contracts !== null) {
            return this.contracts.some(
              (contract) => contract.contract_plan.engine == engine,
            );
          }
          return false;
        }
      };
    },
    hasEngineTypesMi1() {
      return this.hasEngineTypes("mi1");
    },
    hasEngineTypesMi2() {
      return this.hasEngineTypes("mi2");
    },
    hasEngineTypesMi2_1() {
      return this.hasEngineTypes("mi2.1");
    },
    hasEngineTypesCo1() {
      return this.hasEngineTypes("co1");
    },
    hasEngineTypesCo2() {
      return this.hasEngineTypes("co2");
    },
    hasEngineTypesCo2_1() {
      return this.hasEngineTypes("co2.1");
    },
    hasEngineTypesBr1() {
      return this.hasEngineTypes("br1");
    },
    hasEngineTypesSl1() {
      return this.hasEngineTypes("sl1");
    },
    hasEngineOptions() {
      return (engine, options) => {
        const userInfo = useUserInfoStore();
        if (userInfo.isPst) {
          return true;
        } else {
          if (this.contracts !== null) {
            return this.contracts.some(
              (contract) =>
                contract.contract_plan.engine == engine &&
                _.isEqual(contract.contract_plan.engine_options, options),
            );
          }
          return false;
        }
      };
    },
    isOutputStenScore() {
      return this.hasEngineOptions("mi1", { output_sten_score: true });
    },
  },
  actions: {
    setContracts(contracts) {
      this.contracts = contracts;
    },
    reset() {
      this.$reset();
    },
  },
  persist: {
    storage: sessionStorage,
  },
});
